import { LocationSummary } from "../../constants/action-constants/LocationSummaryActionConstants";

// initial state
const initialState = {
  //location summary
  locationSummaryInfoLoading: false,
  locationSummaryInfo: "",
  locationSummaryInfoErr: "",

  // landmark nearby modal
  openLandmarkNearbyModal: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LocationSummary.GET_LOCATION_SUMMARY:
      return {
        ...state,
        locationSummaryInfoLoading: true,
      };

    case LocationSummary.GET_LOCATION_SUMMARY_SUCCESS: {
      return {
        ...state,
        locationSummaryInfo: action.payload,
        locationSummaryInfoLoading: false,
      };
    }

    case LocationSummary.GET_LOCATION_SUMMARY_FAILURE: {
      return {
        ...state,
        locationSummaryInfoLoading: false,
        locationSummaryInfoErr: action.payload,
      };
    }

    case LocationSummary.RESET_LOCATION_SUMMARY: {
      return initialState;
    }

    case LocationSummary.OPEN_LANDMARK_NEARBY_MODAL:
      return {
        ...state,
        openLandmarkNearbyModal: true,
      };
    case LocationSummary.CLOSE_LANDMARK_NEARBY_MODAL:
      return {
        ...state,
        openLandmarkNearbyModal: false,
      };

    default:
      return state;
  }
};
